import { Link } from 'react-router-dom';
import "./CopyrightBox.scss"

const CopyrightBox = () => {

    return (
        <section className='copyright'>
            <p className="footer__info">© ООО ЕКОМСЕЛЛЕР, {new Date().getFullYear()} г. Все права защищены.</p>
            <Link
                to="https://ecomru.ru/ru/article/publichnaja_oferta_predlozhenie_o_zakljuchenii_dogovora_okazanija_uslug_distantsionnym_sposobom/6863"
                target="_blank"
                className="footer__link">Пользовательское соглашение</Link>
            {/* <Link to="#" className="footer__link">Политика оплаты и возврата</Link> */}
            <Link
                to="https://ecomru.ru/ru/article/politika_konfidentsialnosti/6734"
                target="_blank"
                className="footer__link">Политика конфиденциальности</Link>
            <p className="footer__info country" style={{ 'border': 'none' }}>Россия</p>
        </section>
    )
}

export { CopyrightBox }